<aside class="social-channel">
  @if (title(); as title) {
    <h3 class="social-channel__title text-on-surface">{{ title }}</h3>
  }
  <ul class="follow-button-list">
    @for (channel of channels(); track channel.id) {
      <li class="follow-button-list__item">
        <a [href]="channel.url" target="_blank" class="button button-link button--light button--{{ buttonSize() }} px-0">
          <span class="sr-only">{{ channel.title }}</span>

          <!--@if (item.imageUrl) {
            <img [src]="item.imageUrl" [alt]="item.title" />
          }-->

          @if (channel.icon || (channel.url | socialIcon); as icon) {
            <fstr-icon [anchor]="icon" [title]="channel.title"></fstr-icon>
          }
        </a>
      </li>
    }
  </ul>
</aside>
